"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDoubleClickPreviewHandler = exports.useDoubleClick = void 0;
var useDoubleClick = function (_a) {
    var onSingleClick = _a.onSingleClick, onDoubleClick = _a.onDoubleClick;
    var handleClick = function (event) {
        switch (event.detail) {
            case 1: {
                onSingleClick();
                break;
            }
            case 2: {
                onDoubleClick();
                break;
            }
            default: {
                break;
            }
        }
    };
    return handleClick;
};
exports.useDoubleClick = useDoubleClick;
var createDoubleClickPreviewHandler = function (onSingleClick, onDoubleClick) {
    var clickCount = 0;
    var timer = null;
    return function () {
        clickCount++;
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(function () {
            if (clickCount === 1) {
                onSingleClick();
            }
            else if (clickCount === 2) {
                onDoubleClick();
            }
            clickCount = 0;
            timer = null;
        }, 190);
    };
};
exports.createDoubleClickPreviewHandler = createDoubleClickPreviewHandler;
